import devicepresets from "../../../../assets/images/docs/devicepresets.png";
import * as React from 'react';
export default {
  devicepresets,
  React
};